// Full-document render of the Oscar account-profile (display) view:
// PageSkeleton wrapping ProfilePageBody.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { ProfilePageBody } from "../components/ProfilePageBody";

export const Template = (
    props: templates.ProfileDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <ProfilePageBody {...props} />
    </PageSkeleton>
);
